<template>
  <v-container style="z-index: 999;">
    <v-layout row wrap>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list>
        <v-list-tile v-for="(link, linkId) in links" :key="linkId" router :exact="link.exact" :to="{ name: link.link }">
          <v-list-tile-content>
            <v-list-tile-title>{{ link.linkTitle }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-btn color="warning" active-class="podcast-active" outline flat :to="{ name: 'podcast' }"><v-icon left size="24px">mic</v-icon> Podcast</v-btn>
    </v-navigation-drawer>
    <v-toolbar
      flat
      class="py-3"
      style="background-color: transparent;"
    >

      <div style="width: 200px;">
        <div class="logotype-wrapper">
          <router-link :to="{name: 'home' }" tag="a">
            <img class="logotype" src="../assets/logotype.svg" alt="Logotype der Ideenpioniere"/>
          </router-link>
        </div>
      </div>

      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn color="white" v-for="(link, linkIndex) in links" :key="linkIndex" flat :exact="link.exact" :to="{name: link.link }">{{ link.linkTitle }}</v-btn>
      </v-toolbar-items>

      <div>
        <v-toolbar-side-icon outline color="white" class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </div>
    </v-toolbar>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      drawer: false,
      links: [
        {
          link: 'home',
          linkTitle: 'Start',
          exact: true
        },
        {
          link: 'achtsamkeitskarten',
          linkTitle: 'Für Dich',
          exact: false
        },
        {
          link: 'ideenparty',
          linkTitle: 'Ideenparty',
          exact: false
        },
        {
          link: 'podcast',
          linkTitle: 'Podcast',
          exact: false
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  .v-btn.podcast-active {
    visibility: hidden;
  }
  .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
    background-color: transparent;
  }
  .v-btn--active .v-btn__content {
    text-decoration: underline;
  }
  .header {
    border-bottom: 1px solid #D2DFE6;
  }
 .logotype {
    height: 50px;
    display: block;
  }
  .header .logotype-wrapper {
    display: table;
    width: 200px;
    height: 120px;
    float: left;
  }
  .header .logotype-wrapper a {
    display: table-cell;
    vertical-align: middle;
  }
  .header nav {
    display: table;
    height: 120px;
    width: calc(100% - 200px);
    margin-left: 200px;
  }
  .header nav ul {
    display: table-cell;
    height: 50px;
    vertical-align: middle;
    text-align: right;

    li {
      float: right;
      padding: 0px 20px;
    }

    a.router-link-active {
      color: #88C6BC;
    }
  }
  @media screen and (max-width: 400px) {
    .header .logotype-wrapper {
      float: none;
      margin: 0px auto;
    }
    .header nav {
      display: none;
    }
  }
</style>
